import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function UseCasesSection() {
  const useCases = ['Transform a conference into a Livable Book', 'Build a community-driven innovation lab', 'Capture institutional knowledge before it disappears', 'Design a 30-day challenge powered by real insights', 'Create a lifelong learning journey'];
  return <section className="py-24 bg-gray-50" data-id="element-196">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="text-center mb-12" data-id="element-198">
          <h2 className="text-teal-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-199">
            Practicality
          </h2>
          <h3 className="text-3xl font-bold text-gray-900" data-id="element-200">
            Real-World Use Cases
          </h3>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12" data-id="element-201">
          <ul className="space-y-6" data-id="element-202">
            {useCases.map((useCase, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: idx * 0.1
          }} className="flex items-center gap-4 text-lg text-gray-700" data-id="element-203">
                <div className="shrink-0 text-teal-600" data-id="element-204">
                  <CheckCircle size={24} data-id="element-205" />
                </div>
                <span className="font-medium" data-id="element-206">{useCase}</span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}